import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function Proof() {
  return <section className="py-16 px-4 bg-teal-900 text-white" data-id="element-220">
      <div className="max-w-3xl mx-auto text-center" data-id="element-221">
        <h2 className="text-3xl font-bold mb-8 text-teal-50" data-id="element-222">
          Lo que cambia en 7 días:
        </h2>

        <div className="bg-teal-800/50 border border-teal-700 p-8 rounded-2xl shadow-2xl" data-id="element-223">
          <p className="text-xl md:text-2xl leading-relaxed font-medium text-teal-50" data-id="element-224">
            Pasarás de encontrar liendres vivas y ver a tu hijo rascarse con
            desesperación, a tener un{' '}
            <strong className="text-white bg-teal-600/50 px-2 py-1 rounded" data-id="element-225">
              cuero cabelludo limpio
            </strong>
            , una almohada libre de parásitos y la seguridad total de que el
            lunes el niño entrará a clase sin que nadie note absolutamente nada.
          </p>
        </div>
      </div>
    </section>;
}